(function() { window.GUID_aa0be28f_8271_426c_a863_0ca2cc1aa8b6 = { getGuid: function() { return "aa0be28f-8271-426c-a863-0ca2cc1aa8b6"; } }; })();
var CS;
(function (CS) {
    var Enumeration;
    (function (Enumeration) {
        let SortDirection;
        (function (SortDirection) {
            SortDirection[SortDirection["Ascending"] = 0] = "Ascending";
            SortDirection[SortDirection["Descending"] = 1] = "Descending";
        })(SortDirection = Enumeration.SortDirection || (Enumeration.SortDirection = {}));
    })(Enumeration = CS.Enumeration || (CS.Enumeration = {}));
})(CS || (CS = {}));

//# sourceMappingURL=SortDirection.pre.js.map
